module.exports = __webpack_public_path__ + "static/img/immediately_active.63aeec9f.png";